<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-2">
              <div class="label mt-2">Select GRO Site:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="GRO" :options="GRO_options"
                label="Select GRO Site:" @change="onChangeGRO"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">Member:</div>
              <b-form-select v-model="member" :options="member_options" label="SA:" @change="onChangeMember"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">Manager Role:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="role" :options="group_options"
                label="Select GRO Site:" @change="onChangeRole"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">Manager:</div>
              <b-form-select v-model="manager" :options="manager_options" label="SA:" @change="onChangeManager"></b-form-select>
            </div>
            <div class="col-auto align-self-end mx-xs-5">
              <b-button @click="addMember()" variant="primary">Add</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="table_show==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="RoleData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(uni_id)="data">
            <span>
              {{data.item.uni_id}}
            </span>
          </template>

          <template #cell(gro)="data">
            <span>
              {{data.item.gro}}
            </span>
          </template>

          <template #cell(gulid)="data">
            <span>
              {{data.item.gulid}}
            </span>
          </template>

          <template #cell(func_group)="data">
            <span>
              {{data.item.func_group}}
            </span>
          </template>

          <template #cell(manager)="data">
            <span>
              {{data.item.manager}}
            </span>
          </template>

          <template #cell(create_date)="data">
            <span>
              {{data.item.create_date}}
            </span>
          </template>

          <template #cell(create_by)="data">
            <span>
              {{data.item.create_by}}
            </span>
          </template>

          <template #cell(action)="data">
            <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                @click="$emit('deleteModal', 'role', data.item, member)"></button>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    props: ['RoleData', 'member_options', 'group_options', 'manager_options', 'table_show', ],
    watch: {
      member_options: function(newVal, oldVal) { // watch it
        if (newVal.length) {
          this.member = newVal[0].value
        }
        else {
          this.member = ''
        }
        console.log(newVal)
      },
      manager_options: function(newVal, oldVal) { // watch it
        if (newVal.length) {
          this.manager = newVal[0].value
        }
        else {
          this.manager = ''
        }
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Member Manager Role Setting',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        GRO_options_default: '',
        GRO_options: [{ value: '', text: '---Select One---' }],
        GRO: '',
        GROText: '',
        member: '',
        manager: '',
        role: '',

        pages: [
          { text: 'Admin-Member Setting', href: '' },
          { text: 'Manager Role Setting', active: true }
        ],

        fields: [
          { key: 'uni_id', label: 'uni_id', thClass: 'align-middle', sortable: true },
          { key: 'gro', label: 'Site', thClass: 'align-middle', sortable: true },
          { key: 'gulid', label: 'Member_gulid', thClass: 'align-middle', sortable: true },
          { key: 'func_group', label: '  Function_group', thClass: 'align-middle', sortable: true },
          { key: 'manager', label: 'Manager', thClass: 'align-middle', sortable: true },
          { key: 'create_date', label: 'Create_date', thClass: 'align-middle', sortable: true },
          { key: 'create_by', label: 'Create_by', thClass: 'align-middle', sortable: true },
          { key: 'action', label: 'Action', thClass: 'align-middle', sortable: false }
        ],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
      }
    },
    created() {
      let self = this;

    },
    computed: {

    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.pages[0]['href'] = this.$root.frontEndUrl + "/admin-member/setting"
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        gro_option_new[0].text = '---Select One---'
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;

      },
      addMember() {
        let self = this;
        if (self.member == '') {
          self.$message.warning('Missing selections');
        }
        else {
          let request_data = {
            action: 'add',
            GRO: self.GRO,
            member: self.member,
            role: self.role,
            manager: self.manager,
            create_date: self.$root.getTime()
          };
          self.$parent.getRole(request_data)
        }
      },
      onChangeGRO(GRO) {
        let self = this;
        let groText = GRO
        self.role = self.group_options[0].value
        self.GRO = GRO
        if('' === GRO){
          groText = '---Select One---';
        }
        else {
          let request_data = {
            action: 'load',
            GRO: self.GRO,
          };
          self.$parent.getRole(request_data)
        }
      },
      onChangeMember(member) {
        let self = this;
        let memberText = member;
        self.member = member
        if('' === member){
          memberText = 'ALL';
        }
      },
      onChangeRole(role) {
        let self = this;
        let roleText = role;
        self.role = role
        if('' === role){
          roleText = self.group_options[0].value;
        }
      },
      onChangeManager(manager) {
        let self = this;
        let managerText = manager;
        self.manager = manager
        if('' === manager){
          managerText = self.manager_options[0].value;
        }
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RoleSetting.vue